import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

function useGiftItem(giftItemId: string) {
  const { data, status } = useQuery(queries.giftItem.detail(giftItemId));
  const { pop } = useFlow();
  const toast = useToast();
  useEffect(() => {
    if (status === 'error') {
      toast.error('선물 정보를 불러오는데 실패했습니다.');
      pop();
    }
  }, [pop, toast, status]);
  return data;
}

export default useGiftItem;
